export default __webpack_public_path__ + "static/media/alert-tooltip.6d92d027.svg";